import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  text: {
    padding: '1rem 0',
    marginBottom: '1rem',
    width: '100%',
    textAlign: 'center',
  }
});


const QuestionText = ({children}) => {
  const classes = useStyles();
  return (
    <Typography variant="h2" color="primary" className={classes.text}>
      {children}
    </Typography>
  );
};

QuestionText.propTypes = {
  children: PropTypes.string.isRequired,
};

export default QuestionText;
